module.exports = __webpack_public_path__ + "img/choixAsq.1dc38e44.jpg";